<ng-scrollbar class="sidebar-container perfect-scrollbar">
    <!-- My Business -->
    <ul class="sub-menu-v2" [class.active]="routerUrl.startsWith('/account') && !RouteLessPanels()" *ngIf="showMyBusinessSubpanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>
        <li class="sidebar2-radio-dropdown" [ngClass]="getDropdownClasses('business-account')">
            <app-sidebar2-radio-dropdown
                heading="Business Account"
                settingsFlag="NavigationV2MyBusiness"
                defaultRoute="/account/details"
                [defaultQueryParams]="{ submenu: 'business-account' }"
                [options]="accountOptions['Business Account']">
            </app-sidebar2-radio-dropdown>
        </li>

        <li class="sidebar2-radio-dropdown" [ngClass]="getDropdownClasses('business-setup')">
            <app-sidebar2-radio-dropdown
                heading="Business Setup"
                settingsFlag="NavigationV2MyBusiness"
                defaultRoute="/account/setup/businessdocuments"
                [defaultQueryParams]="{ submenu: 'business-setup' }"
                [options]="accountOptions['Business Setup']">
            </app-sidebar2-radio-dropdown>
        </li>
        <li>
            <app-sidebar2-subpanel-tenants *ngIf="showTenantHierarchy" [dropDownClasses]="getDropdownClasses('price-lists')">
            </app-sidebar2-subpanel-tenants>
        </li>
        <li class="sidebar2-radio-dropdown" [ngClass]="getDropdownClasses('business-api')" *ngIf="showAPIWebhooks">
            <app-sidebar2-radio-dropdown
                heading="API"
                settingsFlag="NavigationV2MyBusiness"
                defaultRoute="/account/api/webhooks"
                [defaultQueryParams]="{ submenu: 'business-api' }"
                [options]="accountOptions['Business API']">
            </app-sidebar2-radio-dropdown>
        </li>
    </ul>

    <!-- Dashboard (No subpanel)  -->

    <!-- Leads (new angular) -->
    <app-sidebar2-subpanel-leads *ngIf="showLeadsSubpanel" routeLessPanels="RouteLessPanels"> </app-sidebar2-subpanel-leads>

    <!-- Estimates -->
    <ul class="sub-menu-v2" [class.active]="routerUrl.startsWith('/estimates') && !RouteLessPanels()" *ngIf="showEstimatesSubpanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>
        <li class="sidebar2-checkbox-dropdown" [ngClass]="getDropdownClasses('estimates')">
            <app-sidebar2-checkbox-dropdown
                heading="Estimates"
                paramName="status"
                settingsFlag="NavigationV2Estimates"
                defaultRoute="/estimates/list"
                [defaultQueryParams]="{ submenu: 'estimates' }"
                [options]="estimateStatuses">
            </app-sidebar2-checkbox-dropdown>
        </li>
        <li class="sidebar2-option" [ngClass]="getDropdownClasses('templates', true)">
            <app-sidebar2-option
                heading="Templates"
                settingsFlag="NavigationV2Estimates"
                defaultRoute="/estimates/list"
                [defaultQueryParams]="{ subpanel: 'true', submenu: 'templates', type: 'template' }">
            </app-sidebar2-option>
        </li>
    </ul>

    <!-- jobs -->
    <ul class="sub-menu-v2" [class.active]="routerUrl.startsWith('/jobs') && !RouteLessPanels()" *ngIf="showJobsSubpanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>
        <li class="sidebar2-checkbox-dropdown" [ngClass]="getDropdownClasses('jobs')">
            <app-sidebar2-checkbox-dropdown
                heading="Jobs"
                paramName="status"
                settingsFlag="NavigationV2Jobs"
                defaultRoute="/jobs/list"
                [defaultQueryParams]="{ submenu: 'jobs' }"
                [options]="jobStatuses">
            </app-sidebar2-checkbox-dropdown>
        </li>
        <li
            class="sidebar2-checkbox-dropdown"
            [ngClass]="getDropdownClasses('orders')"
            *ngIf="featureService.isStateAvailable('jobs.all-orders')">
            <app-sidebar2-checkbox-dropdown
                heading="Orders"
                paramName="status"
                settingsFlag="NavigationV2Jobs"
                defaultRoute="/jobs/orders"
                [defaultQueryParams]="{ submenu: 'orders' }"
                [options]="mapToArray(orderCounts)">
            </app-sidebar2-checkbox-dropdown>
        </li>
        <li
            class="sidebar2-checkbox-dropdown"
            [ngClass]="getDropdownClasses('invoices')"
            *ngIf="
                featureService.isStateAvailable('jobs.all-invoices') &&
                featureService.isStateAvailable('jobs.view.invoices') &&
                permissionService.isAvailable('jobs.maintain-invoices.view-invoice-details')
            ">
            <app-sidebar2-checkbox-dropdown
                heading="Invoices"
                paramName="status"
                settingsFlag="NavigationV2Jobs"
                defaultRoute="/jobs/invoices"
                [defaultQueryParams]="{ submenu: 'invoices' }"
                [options]="mapToArray(invoiceCounts)">
            </app-sidebar2-checkbox-dropdown>
        </li>

        <li
            class="sidebar2-checkbox-dropdown"
            [ngClass]="getDropdownClasses('imported-bills')"
            *ngIf="
                (canViewImportedBills$ | async) &&
                featureService.isStateAvailable('jobs.all-invoices') &&
                featureService.isStateAvailable('jobs.view.invoices') &&
                permissionService.isAvailable('jobs.maintain-invoices.view-invoice-details') &&
                permissionService.isAvailable('jobs.maintain-purchase-orders.create-purchase-order')
            ">
            <app-sidebar2-checkbox-dropdown
                heading="Imported Bills"
                paramName="status"
                settingsFlag="NavigationV2Jobs"
                defaultRoute="/jobs/accounting/import-bills"
                [defaultQueryParams]="{ submenu: 'imported-bills' }"
                [options]="[]"
                [showChevron]="false">
            </app-sidebar2-checkbox-dropdown>
        </li>

        <li class="sidebar2-option" [ngClass]="getDropdownClasses('imported-timesheets')">
            <app-sidebar2-checkbox-dropdown
                heading="Imported Timesheets"
                paramName="status"
                settingsFlag="NavigationV2Jobs"
                defaultRoute="/jobs/import-timesheets"
                [defaultQueryParams]="{ submenu: 'imported-timesheets' }"
                [options]="[]"
                [showChevron]="false">
            </app-sidebar2-checkbox-dropdown>
        </li>
    </ul>

    <!-- request for quotes -->

    <ul
        class="sub-menu-v2"
        [class.active]="routerUrl.startsWith('/quoterequests') && !RouteLessPanels()"
        *ngIf="showRequestForQuotesSubpanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>
        <li class="sidebar2-checkbox-dropdown" [ngClass]="getDropdownClasses('request-for-quotes')">
            <app-sidebar2-checkbox-dropdown
                heading="Request for Quotes"
                paramName="status"
                settingsFlag="NavigationV2QuoteRequests"
                defaultRoute="/quoterequests/list"
                [defaultQueryParams]="{ submenu: 'request-for-quotes' }"
                [options]="quoteRequestStatuses">
            </app-sidebar2-checkbox-dropdown>
        </li>
    </ul>

    <!-- clients -->
    <ul class="sub-menu-v2" [class.active]="routerUrl.startsWith('/customers') && !RouteLessPanels()" *ngIf="showClientsSubpanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>
        <li class="sidebar2-checkbox-dropdown" [ngClass]="getDropdownClasses('clients')">
            <app-sidebar2-checkbox-dropdown
                heading="Clients"
                paramName="type"
                settingsFlag="NavigationV2Clients"
                defaultRoute="/customers/list"
                [defaultQueryParams]="{ submenu: 'clients' }"
                [options]="customerStatuses">
            </app-sidebar2-checkbox-dropdown>
        </li>
        <li
            class="sidebar2-checkbox-dropdown"
            [ngClass]="getDropdownClasses('connections')"
            *ngIf="featureService.isAvailable('merchant') || featureService.isAvailable('manufacturer')">
            <app-sidebar2-checkbox-dropdown
                heading="Connections"
                paramName="type"
                settingsFlag="NavigationV2ClientsConnections"
                defaultRoute="/customers/connections"
                [defaultQueryParams]="{ submenu: 'connections' }"
                [options]="connectionStatus">
            </app-sidebar2-checkbox-dropdown>
        </li>
    </ul>

    <!-- contacts -->
    <ul class="sub-menu-v2" [class.active]="routerUrl.startsWith('/contacts') && !RouteLessPanels()" *ngIf="showContactsSubpanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>
        <li class="sidebar2-checkbox-dropdown" [ngClass]="getDropdownClasses('contacts')">
            <app-sidebar2-checkbox-dropdown
                heading="Contacts"
                paramName="group"
                settingsFlag="NavigationV2Contacts"
                defaultRoute="/contacts/list"
                [defaultQueryParams]="{ submenu: 'contacts' }"
                [options]="contactStatuses">
            </app-sidebar2-checkbox-dropdown>
        </li>
    </ul>

    <!-- Communications -->

    <ul class="sub-menu-v2" [class.active]="routerUrl.startsWith('/messages') && !RouteLessPanels()" *ngIf="showCommunicationsSubpanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>
        <li class="sidebar2-radio-dropdown" [ngClass]="getDropdownClasses('communications')">
            <app-sidebar2-radio-dropdown
                heading="Communications"
                settingsFlag="NavigationV2Communications"
                defaultRoute="/messages/email"
                [defaultQueryParams]="{ submenu: 'communications' }"
                [options]="communicationsOptions?.Communications">
            </app-sidebar2-radio-dropdown>
        </li>
    </ul>

    <!-- Catalogues New Angular -->
    <app-sidebar2-subpanel-catalogues
        *ngIf="showCataloguesSubpanel"
        routeLessPanels="RouteLessPanels"
        [dropDownClasses]="getDropdownClasses('price-lists')">
    </app-sidebar2-subpanel-catalogues>

    <!-- Integrations V2 -->
    <ul
        class="sub-menu-v2"
        [class.active]="
            (routerUrl.startsWith('/integrations') || routerUrl.startsWith('/account/setup/integrations')) && !RouteLessPanels()
        "
        *ngIf="showIntegrationsSubpanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>

        <li class="sidebar2-dropdown active" *ngIf="integrationsActive" [ngClass]="{ open: toggle_Connections }">
            <header (click)="fnToggleIntegrationsConnections()" class="sub-menu-v2--header">
                <label>Connections</label>
                <i class="icon-ic-chevron-s1 icon-ic-chevron--expandable"></i>
            </header>
            <app-integrations-active *ngIf="toggle_Connections"></app-integrations-active>
        </li>

        <app-sidebar2-subpanel-integrations [heading]="'Integrations'"></app-sidebar2-subpanel-integrations>
    </ul>

    <!-- My Profile (Account) -->
    <ul class="sub-menu-v2" *ngIf="settings.ShowMyProfilePanel" [class.active]="settings.ShowMyProfilePanel">
        <sidebar2-menulock-angular></sidebar2-menulock-angular>
        <li class="sidebar2-dropdown active" [ngClass]="{ open: toggle_MyProfile }">
            <header (click)="fnToggleMyProfile()" class="sub-menu-v2--header">
                <i class="icon-ic-profile-s1 heading-logo"></i>
                <label>My Profile</label>
                <i class="icon-ic-chevron-s1 icon-ic-chevron--expandable"></i>
            </header>
            <app-form-my-profile *ngIf="toggle_MyProfile" (showAppVersionTrigger)="showAppVersion = $event"></app-form-my-profile>
        </li>
        <li class="sidebar2-dropdown" *ngIf="hasMultipleTenants">
            <header (click)="fnSwitchTenant($event)" class="sub-menu-v2--header">
                <i class="icon-ic-switch-accounts-s1 heading-logo"></i>
                <label>Switch Business</label>
            </header>
        </li>
        <li class="sidebar2-dropdown">
            <header (click)="fnSignOut()" class="sub-menu-v2--header">
                <i class="icon-ic-signout-s1 heading-logo"></i>
                <label>Log Out</label>
            </header>
        </li>
    </ul>

    <!-- Explore options -->
    <ul class="sub-menu-v2" *ngIf="settings.ShowExplorePanel" [class.active]="settings.ShowExplorePanel">
        <li>
            <sidebar2-menulock-angular></sidebar2-menulock-angular>
        </li>

        @if (exploreMoreWithResources()) {
            <li class="sidebar2-option">
                <a href="https://www.facebook.com/groups/599875418637774/" id="live-community-link" class="sidebar-v2-link" target="_blank">
                    <div class="item-content">
                        <div class="item-inner">
                            <span class="title">Live Community</span>
                            <i class="icon-ic-external-link-s1 icon-outline"></i>
                            <i class="icon-ic-external-link-s2 icon-filled"></i>
                        </div>
                    </div>
                </a>
            </li>

            <li class="sidebar2-option" [routerLinkActive]="'active'">
                <a [routerLink]="['resources', 'content']" class="sidebar-v2-link">
                    <div class="item-content">
                        <div class="item-inner"><span class="title">Watch & Learn</span></div>
                    </div>
                </a>
            </li>
            <li class="sidebar2-option" [routerLinkActive]="'active'">
                <a [routerLink]="['resources', 'partners']" class="sidebar-v2-link">
                    <div class="item-content">
                        <div class="item-inner"><span class="title">Partners</span></div>
                    </div>
                </a>
            </li>
        }

        <li class="sidebar2-option">
            <a #alink class="sidebar-v2-link" id="btn-explore-whats-new" href="https://news.buildxact.com/" target="_blank">
                <div class="item-content">
                    @if (!exploreMoreWithResources()) {
                        <div class="item-media">
                            <i class="icon-ic-whats-new-s1 icon-outline"></i>
                            <i class="icon-ic-whats-new-s2 icon-filled"></i>
                        </div>
                    }
                    <div class="item-inner">
                        <span class="title">What&rsquo;s New</span>
                        <i class="icon-ic-external-link-s1 icon-outline"></i>
                        <i class="icon-ic-external-link-s2 icon-filled"></i>
                    </div>
                </div>
            </a>
        </li>

        <li class="sidebar2-option">
            <a class="sidebar-v2-link" #alink (click)="toggleFeatureSuggestions(alink)">
                <div class="item-content">
                    @if (!exploreMoreWithResources()) {
                        <div class="item-media">
                            <i class="icon-ic-suggest-to-us-s11 icon-outline"></i>
                            <i class="icon-ic-suggest-to-us-s1 icon-filled"></i>
                        </div>
                    }
                    <div class="item-inner" id="suggest-to-us-button">
                        <span class="title">Feature Suggestions</span>
                        <i class="icon-ic-external-link-s1 icon-outline"></i>
                        <i class="icon-ic-external-link-s2 icon-filled"></i>
                    </div>
                </div>
            </a>
        </li>
    </ul>
    <div *ngIf="showAppVersion" style="text-align: end; padding-right: 15px">
        <span>{{ appVersion }}</span>
    </div>
</ng-scrollbar>
